import * as React from "react";
import * as _ from "lodash";
import logger from "./Logger.js";
const ApplyOnClickInterceptor = () => {
  const createElement = React.createElement;
  const maxTextLength = 30;
  let lastClickEventLoggedTimeStamp;
  React.createElement = (type, props, ...children) => {
    let element;
    if (props && (props.onClick || props.href) && typeof type === "string") {
      const originalClickHandler = props.onClick;
      const newCallback = function(event, ...args) {
        var _a, _b, _c;
        if (event && event.timeStamp) {
          if (!lastClickEventLoggedTimeStamp || lastClickEventLoggedTimeStamp !== event.timeStamp) {
            const owner = element._owner;
            const reactRef = owner && owner._context;
            const parentLoggingContext = reactRef && reactRef.loggingContext || {};
            const parentContext = {
              clickEventProperties: {
                context: parentLoggingContext
              }
            };
            let currentContext = {};
            if (event && event.target) {
              const eventTargetElement = event.target;
              let targetText = (_c = (_a = props["aria-label"]) != null ? _a : props["title"]) != null ? _c : (_b = eventTargetElement.innerText) == null ? void 0 : _b.substring(0, maxTextLength);
              let dataTelemetryId = props["data-telemetry-id"];
              currentContext = _.extend({ text: targetText, dataTelemetryId }, parentContext, props);
            } else {
              let dataTelemetryId = props["data-telemetry-id"];
              currentContext = _.extend({ dataTelemetryId }, parentContext, props);
            }
            logger.clickEvent(type, currentContext);
          }
          lastClickEventLoggedTimeStamp = event.timeStamp;
          if (originalClickHandler) {
            originalClickHandler(event, ...args);
          }
        }
      };
      props.onClick = newCallback;
      const innerProperties = _.clone(props);
      delete innerProperties.clickEventProperties;
      element = createElement(type, innerProperties, ...children);
      return element;
    } else {
      return createElement(type, props, ...children);
    }
  };
};
export {
  ApplyOnClickInterceptor
};
//# sourceMappingURL=ReactInterceptors.js.map
